export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'
import { recruitmentTrainingNavigationRoute } from './recruitmentTrainingNavigation'

// Don't call getUserRole at module load time - it will be called when needed
const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard-v2',
      displayName: 'Driver Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'dashboard-v2',
          displayName: 'Dashboard',
          meta: {
            icon: 'today',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'performance',
          displayName: 'My Performance',
          meta: {
            icon: 'trending_up',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    {
      name: 'earnings',
      displayName: 'Earnings',
      meta: {
        icon: 'attach_money',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'earnings-overview',
          displayName: 'Earnings Overview',
          meta: {
            icon: 'account_balance_wallet',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'trip-earnings',
          displayName: 'Trip Earnings',
          meta: {
            icon: 'route',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'uber-earnings',
          displayName: 'Uber Earnings',
          meta: {
            icon: 'directions_car',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    {
      name: 'trips',
      displayName: 'My Trips',
      meta: {
        icon: 'route',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'trips',
          displayName: 'Trip History',
          meta: {
            icon: 'route',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'live-trips',
          displayName: 'Live Trips',
          meta: {
            icon: 'gps_fixed',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    {
      name: 'charging',
      displayName: 'Charging',
      meta: {
        icon: 'battery_charging_full',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'charging-map',
          displayName: 'Charging Map',
          meta: {
            icon: 'map',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'charging-sessions',
          displayName: 'Charging Sessions',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'aeversa-charging',
          displayName: 'Aeversa Charging',
          meta: {
            icon: 'ev_station',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    {
      name: 'support',
      displayName: 'Support',
      meta: {
        icon: 'help',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'live-help',
          displayName: 'Live Help',
          meta: {
            icon: 'support_agent',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'tickets',
          displayName: 'My Tickets',
          meta: {
            icon: 'assignment',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'faq',
          displayName: 'FAQ',
          meta: {
            icon: 'help_outline',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    {
      name: 'notifications',
      displayName: 'Notifications',
      meta: {
        icon: 'notifications',
        allowedRoles: ['driver'],
      },
      children: [
        {
          name: 'whatsapp',
          displayName: 'WhatsApp',
          meta: {
            icon: 'chat',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'sms',
          displayName: 'SMS',
          meta: {
            icon: 'message',
            allowedRoles: ['driver'],
          },
        },
        {
          name: 'email',
          displayName: 'Email',
          meta: {
            icon: 'email',
            allowedRoles: ['driver'],
          },
        },
      ],
    },
    recruitmentTrainingNavigationRoute,
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['driver'],
      },
    },
  ],
}

export default sidebarRoutes
